export function getStatusColor(status: string): string {
  switch (status) {
    case 'PENDING': return 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200';
    case 'RUNNING': return 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200';
    case 'COMPLETED': return 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200';
    case 'PAUSED': return 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-200';
    case 'FAILED': return 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-200';
    default: return 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200';
  }
}

export function getStatusText(status: string): string {
  switch (status) {
    case 'PENDING': return 'Aguardando';
    case 'RUNNING': return 'Executando';
    case 'COMPLETED': return 'Concluída';
    case 'PAUSED': return 'Pausada';
    case 'FAILED': return 'Falha';
    default: return status;
  }
}

export function getErrorIcon(errorMessage: string): { icon: string; color: string; bgColor: string; category: string } | null {
  if (!errorMessage || errorMessage === 'N/A') return null;
  const error = errorMessage.toLowerCase();
  if (error.includes('network') || error.includes('connection') || error.includes('timeout')) return { icon: '🌐', color: 'text-orange-600', bgColor: 'bg-orange-100 dark:bg-orange-900/30', category: 'Conectividade' };
  if (error.includes('blocked') || error.includes('banned') || error.includes('spam')) return { icon: '🚫', color: 'text-red-600', bgColor: 'bg-red-100 dark:bg-red-900/30', category: 'Bloqueio' };
  if (error.includes('rate limit') || error.includes('quota') || error.includes('limit')) return { icon: '⏰', color: 'text-yellow-600', bgColor: 'bg-yellow-100 dark:bg-yellow-900/30', category: 'Rate Limit' };
  if (error.includes('invalid') || error.includes('not found') || error.includes('number')) return { icon: '📱', color: 'text-blue-600', bgColor: 'bg-blue-100 dark:bg-blue-900/30', category: 'Número Inválido' };
  if (error.includes('permission') || error.includes('unauthorized') || error.includes('forbidden')) return { icon: '🔒', color: 'text-purple-600', bgColor: 'bg-purple-100 dark:bg-purple-900/30', category: 'Permissão' };
  if (error.includes('session') || error.includes('disconnected') || error.includes('logout')) return { icon: '📲', color: 'text-indigo-600', bgColor: 'bg-indigo-100 dark:bg-indigo-900/30', category: 'Sessão' };
  if (error.includes('media') || error.includes('file') || error.includes('download')) return { icon: '📁', color: 'text-gray-600', bgColor: 'bg-gray-100 dark:bg-gray-700', category: 'Mídia' };
  return { icon: '⚠️', color: 'text-red-600', bgColor: 'bg-red-100 dark:bg-red-900/30', category: 'Erro Geral' };
}

export function formatQuotaErrorForDisplay(text: string | undefined): string {
  if (!text || typeof text !== 'string') return text ?? '';
  const lower = text.toLowerCase();
  if (lower.includes('no lid found')) return 'Número não encontrado no WhatsApp.';
  if (lower.includes('rate-overlimit') || lower.includes('rate limit') || lower.includes('status 429')) {
    return 'Limite temporário do WhatsApp atingido. Tente novamente mais tarde.';
  }
  if (text.startsWith('WAHA API error:')) return 'Não foi possível enviar esta mensagem pelo WhatsApp.';
  let out = text.replace(/\bresetado\b/gi, 'zerado');
  if (out.includes('O contador será') && !out.includes('.\nO contador')) out = out.replace(/\.\s*O contador será/g, '.\nO contador será');
  return out;
}
